import React, {ReactElement, Component, Dispatch, SetStateAction, useContext, useState, useEffect} from 'react';
import {Modal, Form, Row, Col, Input, Select, Button, Tabs, Tooltip, Collapse, Checkbox} from 'antd';
import "../less/service.less";
import {FormattedMessage, injectIntl} from 'react-intl';
import {
    http_get,
    loading_alert_before,
    loading_alert_after,
    random_uuid,
    getPopupNodeModal
} from '../common-file/service';
import {worker_fetch} from "../../../worker/worker-fetch";
import ReactJson from 'react-json-view';
import {DeleteOutlined, PlusOutlined, QuestionCircleOutlined, LoadingOutlined, CheckOutlined, CloseOutlined} from '@ant-design/icons';
import copy from 'copy-to-clipboard';
import Cookies from 'universal-cookie';

// 变量
import {ModalVisibleContext} from '../contexts/modal-visible';
import {ModalDataContext} from '../contexts/modal-data';
import { DatacenternameContext } from "../../../contexts/datacenter-name";
import {ModalLoadingContext} from '../contexts/modal-loading';

// data type
import {modalType, modalDataType, jsonViewType, formResultType} from '../common-file/interfaceType';
import {IUserInfoType, UserInfoContext} from "../../../contexts/user-info";
import {ServiceNameContext} from "../contexts/service-name-select";
import {BrokerPlanResultContext} from '../contexts/broker-plan-result';
import {ListItemSelectedContext} from "../contexts/list-item-selected";

const cookies = new Cookies();

const show_form: any ={
    create: true,
    edit: true,
    rename: true,
    update: true
};

const show_secret: any ={
    create_secret: true,
    create_DCCS: true,
    edit_DCCS: true
};

const show_ok_btn_loading: any ={
    subscription_title: true,
    create_secret: true,
    create_DCCS: true,
    rename_instance: true,
    rename_instance_overview: true,
    overview_create_dedicated: true,
    overview_create_shared: true,
    create_broker_title: true,
    update_broker_title: true
};

const overviewATDB: any ={
    MongoDB: true,
    PostgreSQL: true,
    RabbitMQ: false
};

const hide_dashboard: any ={
    MongoDB: true,
    PostgreSQL: true,
    InfluxDB: true
};

const hide_authentication_database: any ={
    RabbitMQ: true,
    InfluxDB: true
};

const instance_name: any ={
    rename_instance_overview: true,
    rename_instance: true
};

const paddingLeft: object = {paddingLeft: '5px'};
const paddingLR: object = {paddingLeft: '5px', paddingRight: '5px'};
const paddingRight: object = {paddingRight: '5px'};

const Modals: React.FC = (props:any): ReactElement<any,string| (new (props:any)=> Component<any, any, any>)> =>{

    const {intl, history} = props,
        [form] = Form.useForm(),
        user_info: IUserInfoType = useContext(UserInfoContext)[0],
        [modal_visible, set_modal_visible]: [modalType, Dispatch<SetStateAction<modalType>>] = useContext(ModalVisibleContext),
        [modal_data, set_modal_data]:[modalDataType, Dispatch<SetStateAction<modalDataType>>] = useContext(ModalDataContext),
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        [id, set_id]: [number, Dispatch<SetStateAction<number>>] = useState(0),
        [instance_id, set_instance_id]: [number, Dispatch<SetStateAction<number>>] = useState(0),
        [broker_plan_id, set_broker_plan_id]: [number, Dispatch<SetStateAction<number>>] = useState(0),
        [cluster_name, set_cluster_name] = useState([]),
        [workspace_name, set_workspace_name] = useState([]),
        [namespace_name, set_namespace_name]= useState([]),
        [cluster_selected, set_cluster_selected] =useState(null),
        [workspace_selected, set_workspace_selected] = useState(null),
        [keys, set_keys]: [any, Dispatch<SetStateAction<any>>]= useState([]),
        [instance_keys, set_instance_keys]: [any, Dispatch<SetStateAction<any>>]= useState([]),
        [broker_plan_keys, set_broker_plan_keys]: [any, Dispatch<SetStateAction<any>>]= useState([]),
        [db_select_input, set_db_select_input]: [any, Dispatch<SetStateAction<any>>] = useState(''),
        [service_select_input, set_service_select_input]: [any, Dispatch<SetStateAction<any>>] = useState(''),
        [service_plan_select_input, set_service_plan_select_input]: [any, Dispatch<SetStateAction<any>>] = useState(''),
        [service_category_select_input, set_service_category_select_input]: [any, Dispatch<SetStateAction<any>>] = useState(''),
        [charge_type_select_input, set_charge_type_select_input]: [any, Dispatch<SetStateAction<any>>] = useState(''),
        [db_list, set_db_list]: [any, Dispatch<SetStateAction<any>>] = useState(null),
        [form_value_result, set_form_value_result]: [formResultType|any, Dispatch<SetStateAction<formResultType|any>>] = useState({}),
        [check_parameters, set_check_parameters]: [any, Dispatch<SetStateAction<any>>] = useState({}),
        [check_data_service, set_check_data_service]: [any, Dispatch<SetStateAction<any>>] = useState({}),
        [check_broker_plan, set_check_broker_plan]: [any, Dispatch<SetStateAction<any>>] = useState({}),
        [modal_loading, set_modal_loading]: [boolean, Dispatch<SetStateAction<boolean>>] = useContext(ModalLoadingContext),
        [type_data, set_type_data]: [any, Dispatch<SetStateAction<any>>] = useState({}),
        service_name: string = useContext(ServiceNameContext)[0],
        list_item_selected: any = useContext(ListItemSelectedContext)[0],
        // todo modal set subscription list
        // eslint-disable-next-line
        [subscription_list, set_subscription_list]: [any, Dispatch<SetStateAction<any>>] = useState(null),
        [broker_plan_result, set_broker_plan_result]: [any, Dispatch<SetStateAction<any>>] = useContext(BrokerPlanResultContext),
      // eslint-disable-next-line
      [create_instance_info, set_create_instance_info]: [boolean[], Dispatch<SetStateAction<boolean[]>>] = useState<boolean[]>([]),
      [can_init_form, set_can_init_form]: [boolean, Dispatch<SetStateAction<boolean>>] = useState<boolean>(false);

    // const [IoTHub_select_input, set_IoTHub_select_input]: [any, Dispatch<SetStateAction<any>>] = useState('');

    useEffect(()=>{
        if(modal_data.title === 'edit_instance' && can_init_form && list_item_selected?.instanceId){
            // todo 设置edit初始值
            set_can_init_form(false);
            const {service, instanceId} = list_item_selected;
            set_service_select_input(service || '');
            (async ()=>{
                const instance_info: any = await worker_fetch({
                    url: `/serviceHub/v2/userProvided/${instanceId}`,
                    method: 0,
                    props: {formatMessage: intl.formatMessage, history},
                    datacenter_name
                });
                console.log(instance_info);
                if(instance_info.status === 200 && instance_info.data){
                    const {authenticationDatabase, internalHosts, externalHosts, username, ssl} = instance_info.data;
                    form.setFieldsValue({
                        internalHosts: internalHosts || '',
                        externalHosts: externalHosts || '',
                        ssl: ssl? 'true': 'false',
                        username: username ||'',
                        authenticationDatabase: authenticationDatabase || ''
                    });
                }
            })();
        } else if(modal_data.title === "subscription_title") {
            set_service_select_input(form.getFieldValue('serviceNameInstance') || "MongoDB");
        }
        // eslint-disable-next-line
    }, [modal_data.title, list_item_selected]);

    useEffect(()=>{
        if(!modal_visible.toggle) {
            set_db_select_input('');
            set_db_list(null);
            set_cluster_name([]);
            set_workspace_name([]);
            set_namespace_name([]);
            set_cluster_selected(null);
            set_workspace_selected(null);
            set_keys([]);
            set_instance_keys([0]);
            set_broker_plan_keys([0]);
            set_form_value_result({});
            set_check_parameters({});
            set_check_data_service({});
            set_check_broker_plan({});
            set_modal_loading(false);
            set_modal_data({});
            set_broker_plan_result([]);
            set_service_select_input('');
            set_create_instance_info([]);
            set_can_init_form(true);
            // set_subscription_list(null);
            // set_IoTHub_select_input('');
            form.setFieldsValue({
                db: '',
                IoTHub: '',
                serviceName:'',
                serviceInstanceId: '',
                serviceInstanceName: '',
                transactionId: '',
                serviceNameInstance: '',
                servicePlanName: '',
                internalHosts: '',
                externalHosts: '',
                ssl: 'false',
                username: '',
                password: '',
                dashboardUrl: '',
                authenticationDatabase: '',
                location: '',
                databaseVersion: '',
                vmType: '',
                vmSize: '',
                persistentDiskSize: '',
                persistentDiskType: '',
                serviceCategory: '',
                chargeType: '',
                serviceProperty: 'Basic',
                userId: '',
                bindable: 'true',
                instanceKey0: '',
                instanceValue0: '',
                brokerPlan0: '',
                cluster: '',
                workspace: '',
                namespace: '',
                name: '',
                description: '',
                rmqRole: '',
                rmqTopicRead: '',
                rmqTopicWrite: '',
                subscriptionId: '',
                pseudoID: '',
                brokerServiceName: '',
                brokerDisplayName: '',
                protocol: 'http',
                brokerHost: '',
                serviceId: '',
                planId: '',
                userPlans: '',
                updateSecret: false,
                editInstanceCheckbox: false
            });
        }
        // eslint-disable-next-line
    }, [modal_visible]);

    useEffect(()=>{
        if((modal_data?.item?.db || modal_data?.item?.IoTHub) && !db_list && modal_visible.toggle){
            set_db_list([]);
            (async()=>{
                loading_alert_before();
                const {instanceId} = JSON.parse(sessionStorage.getItem('instance_list_item_selected') || '{}'),
                    {data} = await http_get(`/serviceHub/v2/serviceInstances/${instanceId }/resources`, props) as any || {};
                if(data?.resources_list){
                    set_db_list(data.resources_list)
                }
                loading_alert_after();
            })()
        }
        // eslint-disable-next-line
    }, [db_list, modal_data]);

    useEffect(()=>{
        if(modal_data?.item?.cluster && cluster_name.length<=0 && modal_visible.toggle){
            (async()=>{
                loading_alert_before();
                const {data}= await http_get(`/v1/datacenter/${datacenter_name}/clusternames`, props) as any || {};
                let list:any = [];
                let new_form_value_result: formResultType ={
                    workspace: false,
                    namespace: false
                };
                if(data?.items){
                    // eslint-disable-next-line
                    data.items.map((item:any)=>{
                        list.push({
                            key: item.name,
                            ...item
                        })
                    });
                    new_form_value_result ={
                        cluster: list.length<=0,
                        ...new_form_value_result
                    }
                } else{
                    new_form_value_result ={
                        cluster: true,
                        ...new_form_value_result
                    };
                    list.push({});
                }
                set_form_value_result({...new_form_value_result});
                set_cluster_name(list);
                loading_alert_after();
            })()
        }
        // eslint-disable-next-line
    }, [cluster_name, modal_data]);

    useEffect(()=>{
        if(cluster_selected){
            (async ()=>{
                set_workspace_name([]);
                loading_alert_before();
                const {data} = await http_get(`/v1/datacenter/${datacenter_name}/cluster/${cluster_selected}/workspacenames`, props) as any || {};
                let list:any = [];
                let new_form_value_result: formResultType ={
                    cluster: false,
                    namespace: false
                };
                if(data?.items){
                    // eslint-disable-next-line
                    data.items.map((item:any)=>{
                        list.push({
                            key: item.name,
                            ...item
                        })
                    });
                    new_form_value_result.workspace = list.length<=0;
                }else {
                    list.push({});
                    new_form_value_result.workspace = true;
                }
                set_form_value_result(new_form_value_result);
                set_workspace_name(list);
                loading_alert_after();
            })()
        }else {
            set_workspace_name([]);
        }
        form.setFieldsValue({workspace: ''});
        set_workspace_selected(null);
        // eslint-disable-next-line
    }, [cluster_selected]);

    useEffect(()=>{
        const dashboardUrlEle: any= document.getElementById('dashboardUrl') || {attributes:{}},
            authenticationDatabaseEle: any= document.getElementById('authenticationDatabase') || {attributes: {}};
        if(dashboardUrlEle.attributes.hidden !== undefined){
            form.setFieldsValue({
                dashboardUrl: ''
            })
        }
        if(authenticationDatabaseEle.attributes.hidden !== undefined){
            form.setFieldsValue({
                authenticationDatabase: ''
            })
        }
        // eslint-disable-next-line
    }, [service_select_input]);

    useEffect(()=>{
        if(workspace_selected){
            (async ()=>{
                set_namespace_name([]);
                loading_alert_before();
                const {data} = await http_get(`/v1/datacenter/${datacenter_name}/cluster/${cluster_selected}/workspace/${JSON.parse(workspace_selected||"{}").id}/namespacenames`, props) as any || {};
                let list:any = [];
                let new_form_value_result: formResultType ={
                    cluster: false,
                    workspace: false
                };
                if(data?.items){
                    // eslint-disable-next-line
                    data.items.map((item:any)=>{
                        list.push({
                            key: item.name,
                            ...item
                        })
                    });
                    form_value_result.namespace=true;
                    new_form_value_result.namespace = list.length<=0;
                }else {
                    list.push({});
                    new_form_value_result.namespace = true;
                }
                set_form_value_result(new_form_value_result);
                set_namespace_name(list);
                loading_alert_after();
            })()
        }else {
            set_namespace_name([]);
        }
        form.setFieldsValue({namespace: ''})
        // eslint-disable-next-line
    }, [workspace_selected]);

    useEffect(()=>{
        // todo modal get subscriptions list
        // if((modal_data.title === 'overview_create_dedicated' || modal_data?.item?.subscription_all) && modal_visible.toggle && !subscription_list){
        //     (async ()=>{
        //         loading_alert_before();
        //         const {data} = await http_get(`/v4.0/subscriptions?maxResults=999&page=&direction=&property=`, props) as any || {};
        //         if(data?.resources){
        //             let new_list: any =[];
        //             // eslint-disable-next-line
        //             data.resources.map((item: any, key: number)=>{
        //                 const {id, name, company} = item;
        //                 new_list.push({
        //                     key,
        //                     id,
        //                     name,
        //                     company
        //                 })
        //             });
        //             set_subscription_list(new_list)
        //         }
        //         loading_alert_after();
        //     })();
        // }
        if(modal_visible.toggle){
            let set_form_value: any ={};
            const {
                overview_service_name,
                overview_plan,
                bindable,
                // brokerPassword,
                brokerPlanId,
                brokerServiceId,
                // brokerUrl,
                // brokerUser,
                displayName,
                plan,
                service,
            } = modal_data.itemValue || {},
                dataCenter_code: string = (datacenter_name || cookies.get('datacenterCode')).toLowerCase();
            switch (modal_data.title) {
                case 'overview_create_shared':
                    set_form_value = {
                        overviewServiceName: overview_service_name,
                        overviewPlan: overview_plan,
                        datacenterCode: dataCenter_code
                    };
                    break;
                case 'update_broker_title':
                    set_form_value = {
                        brokerServiceName: service,
                        brokerPlan: plan,
                        brokerDisplayName: displayName,
                        bindable,
                        // brokerUrl,
                        // username: brokerUser,
                        // password: brokerPassword,
                        serviceId: brokerServiceId,
                        planId: brokerPlanId
                    };
                    break;
                default: break;
            }
            form.setFieldsValue(set_form_value)
        }
        // eslint-disable-next-line
    }, [modal_data.title]);

    useEffect(()=>{
        if(user_info.ssoRole === 'globalAdmin'){
            const type_1: boolean = service_select_input === 'MongoDB',
                type_2: boolean = service_select_input === 'PostgreSQL',
                type_3: boolean = service_select_input === 'InfluxDB';
            set_create_instance_info([type_1 || type_2 || type_3, type_3, type_1 || type_2])
        }
        // eslint-disable-next-line
    }, [service_select_input, service_plan_select_input]);

    // 添加parameter
    const addParameter = (type: string)=>{
        switch (type) {
            case 'instance':
                (()=>{
                    let new_id: number = instance_id;
                    new_id++;
                    set_instance_id(new_id);
                    const nextKeys: any = instance_keys.concat(new_id);
                    set_instance_keys(nextKeys);
                })();
                break;
            case 'broker':
                (()=> {
                    let new_id: number = broker_plan_id;
                    new_id++;
                    set_broker_plan_id(new_id);
                    const nextKeys: any = broker_plan_keys.concat(new_id);
                    set_broker_plan_keys(nextKeys);
                })();
                break;
            default:
                (()=>{
                    let new_id: number = id;
                    new_id++;
                    set_id(new_id);
                    const nextKeys: any = keys.concat(new_id);
                    set_keys(nextKeys);
                })();
                break;
        }
    };

    // 删除parameter
    const removeParameter= (key:number, type: string, list: any)=>{
        const nexKeys = list.filter((k:number) => k !== key);
        switch (type) {
            case 'key': set_keys(nexKeys); break;
            case 'instanceKey': set_instance_keys(nexKeys); break;
            case 'brokerPlan': set_broker_plan_keys(nexKeys); break;
            default: break;
        }
        check_parameter_key(type, list);
    };
    
    const on_finish = (value: any)=>{
        let can_submit: boolean = db_select_input? testSelectDB(db_select_input) : true;
        if(!can_submit) return;
        if(Object.keys(check_parameters).length > 0) return;
        if(Object.keys(check_broker_plan).length > 0) return;
        for (let key in form_value_result) {
            if (form_value_result[key]) {
                can_submit = false;
                return;
            }
        }
        let new_modal_data: any = {};
        if (value) {
            value.serviceProperty === undefined && (value.serviceProperty = 'Basic');
            const parameters: any = {},
                dataService: any = [],
                brokerPlan: any =[];
            // eslint-disable-next-line
            keys.map((k: number) => {
                const keys: string|undefined = value[`key${k}`];
                if (keys) {
                    const types: string|undefined = value[`type${k}`],
                        values: string|undefined = value[`value${k}`];
                        let arr_val: any = [];
                    try{
                        arr_val = JSON.parse(`[${values}]`)
                    }catch (e) {
                        arr_val = values;
                    }
                    parameters[keys || ''] = types === 'integer'? Number(values):
                        types === 'boolean'? (values !== 'false'):
                            types === 'array'? arr_val:
                                (values|| '');
                }
            });
            value.parameters = parameters;
            // eslint-disable-next-line
            instance_keys.map((k: number) => {
                if (value[`instanceKey${k}`] && value[`instanceValue${k}`]) {
                    dataService.push({
                        pnQuantity: Number(value[`instanceKey${k}`]),
                        pn: value[`instanceValue${k}`]
                    });
                }
            });
            value.dataService = dataService;
            // eslint-disable-next-line
            broker_plan_keys.map((k: number) => {
                (broker_plan_result[k]!== 1) && (brokerPlan[k]=(value[`brokerPlan${k}`]))
            });
            value.brokerPlanList = brokerPlan;
            new_modal_data = {
                ...modal_data,
                formValue: value
            };
        } else {
            new_modal_data = {
                ...modal_data,
                formValue: {}
            }
        }
        set_modal_data(new_modal_data);
        show_ok_btn_loading[modal_data.title || '-1'] ?
            set_modal_loading(true) :
            set_modal_visible({toggle: false, type: modal_visible.type});
    };

    const ok_handle=()=>{
        if(modal_data.title === 'view'|| modal_data.title==='confirm' || modal_data.title==='support_title') {
            on_finish(false);
        }else {
            form.submit();
        }
    };

    const cancel_handle= ()=>{
        set_modal_visible({toggle: false, type: modal_visible.type});
    };

    const check_name_value = ()=>{
        const {datasource} = modal_data;
        let check_result: any =[];
        if(datasource && datasource.length>0) {
            const {name, cluster, workspace, namespace} = form.getFieldsValue();
            check_result = datasource.filter((item: any) => name === item.name && cluster === item.cluster && JSON.parse(workspace || '{}').name === item.workspace && namespace === item.namespace);
        }
        set_form_value_result({
            ...form_value_result,
            name: check_result.length>0
        });
    };

    const check_service_instance_name = (key: string)=>{
        const {serviceInstanceName} = form.getFieldsValue(),
            {datasource} = modal_data,
            {subscriptionId} = JSON.parse(sessionStorage.getItem(key) || '{}');
            let check_result: any;
            switch (key) {
                case 'instance_list_item_selected':
                    check_result = datasource.filter((item: any) => subscriptionId === item.subscriptionId && serviceInstanceName === item.instanceName);
                    break;
                case 'overview_list_item_selected':
                    check_result = datasource.filter((item: any) => serviceInstanceName === item.instanceName);
                    break;
                default: check_result = []; break;
            }
        set_form_value_result({
            ...form_value_result,
            serviceInstanceName: check_result.length>0
        })
    };
    
    const check_parameter_key = (key: string, list: any,) =>{
        let repeat_key: any = {};
        for(let i=0; i<list.length; i++){
            const key_i: number = Number(list[i]),
                  i_value: string | undefined = form.getFieldsValue()[`${key}${key_i}`];
            if(i_value){
                for(let j=i+1; j<list.length; j++){
                    const key_j: number = Number(list[j]),
                          j_value: string | undefined = form.getFieldsValue()[`${key}${key_j}`];
                    if(j_value && i_value === j_value){
                        repeat_key[key_i] = true;
                        repeat_key[key_j] = true;
                    }
                }
            }
        }
        switch (key) {
            case 'key': set_check_parameters(repeat_key); break;
            case 'instanceKey': set_check_data_service(repeat_key); break;
            case 'brokerPlan': set_check_broker_plan(repeat_key); break;
            default: break;
        }
    };

    const testSelectDB = (str: string)=>{
        return /^[a-zA-Z0-9.-]+$/.test(str) && /^[a-zA-Z0-9](.*[a-zA-Z0-9-])?$/.test(str) && str.length <= 63
    };

    // todo modal subscription element
    // eslint-disable-next-line
    const subscription_ele = ()=>(<Col span={24}>
        <Form.Item
            name={'subscriptionId'}
            labelAlign={'left'}
            labelCol={{span: 24}}
            label={'Subscription Name'}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                }
            ]}
        >
            <Select
                showSearch
                getPopupContainer={(node: any)=>getPopupNodeModal(node)}
                filterOption={(input: any, option: any)=>{
                    return option.title.toLowerCase().indexOf(input.toLocaleString()) >=0
                }}
            >
                {subscription_list&&subscription_list.map((item: any)=>(
                    <Select.Option title={`${item.name} --- ${item.company}`} key={item.id} value={item.id}>{item.name}&nbsp;---&nbsp;{item.company}</Select.Option>
                ))}
            </Select>
        </Form.Item>
    </Col>);

    const service_instance_id_ele = (auto: boolean)=>(<Col span={24}>
        <Form.Item
            name={'serviceInstanceId'}
            labelAlign={'left'}
            labelCol={{span: 24}}
            label={auto?
                <span>
                    {intl.formatMessage({id: 'service_instance_id'})}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Tooltip title={intl.formatMessage({id: 'service_instance_id_tooltip'})}>
                        <span className={'click-button'} onClick={()=> form.setFieldsValue({serviceInstanceId: random_uuid()})}>
                            <FormattedMessage id={'auto_input'}/>
                        </span>
                    </Tooltip>
                </span>:
                intl.formatMessage({id: 'service_instance_id'})
            }
            validateStatus={form_value_result.serviceInstanceId? 'error': undefined}
            help={form_value_result.serviceInstanceId?
                intl.formatMessage({id: 'not_a_valid_UUID'}): null
            }
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    pattern: /^[a-f0-9-]+$/,
                    message: intl.formatMessage({id: 'input_regexp_4'})
                },
                {
                    pattern: /^([0-9a-f]{8}-{1}){1}([0-9a-f]{4}-{1}){3}[0-9a-f]{12}$/,
                    message: intl.formatMessage({id: 'not_a_valid_UUID'})
                },
                {
                    max: 50,
                    message: intl.formatMessage({id: 'max_length'}, {length: 50})
                }
            ]}
            validateTrigger={'onBlur'}
        >
            <Input />
        </Form.Item>
    </Col>);

    // todo modal transaction element
    // eslint-disable-next-line
    const transaction_id_ele = ()=>(<Col span={24}>
        <Form.Item
            name={'transactionId'}
            labelAlign={'left'}
            labelCol={{span: 24}}
            label={<span>
                            {intl.formatMessage({id:'transaction_id'})}
                &nbsp;&nbsp;
                <Tooltip title={intl.formatMessage({id: 'enter_any_value'})}>
                                <QuestionCircleOutlined className={'tooltip_question'} />
                            </Tooltip>
                        </span>}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    pattern: /^[a-f0-9-]+$/,
                    message: intl.formatMessage({id: 'input_regexp_4'})
                },
                {
                    max: 150,
                    message: intl.formatMessage({id: 'max_length'}, {length: 150})
                }
            ]}
        >
            <Input />
        </Form.Item>
    </Col>);

    // todo modal service name element
    // eslint-disable-next-line
    const service_name_ele = ()=>(<Col span={12} style={paddingRight}>
        <Form.Item
            name={'serviceNameInstance'}
            label={'Service Name'}
            labelCol={{span: 24}}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    max: 150,
                    message: intl.formatMessage({id: 'max_length'}, {length: 150})
                }
            ]}
            validateStatus={form_value_result.serviceNameInstance? 'error': undefined}
            help={form_value_result.serviceNameInstance?
                intl.formatMessage(
                    {id: 'max_length'},
                    {length: 150}
                ): null
            }
        >
            <Select
                showSearch
                notFoundContent={null}
                showArrow={false}
                onSearch={(e: string)=> {
                    form.setFieldsValue({serviceNameInstance: e || service_select_input});
                    e&&set_service_select_input(e)
                }}
                onKeyUp={(e: any)=>{
                    if(e.keyCode === 8){
                        form.setFieldsValue({serviceNameInstance: ''});
                        set_service_select_input('');
                    }
                    set_form_value_result({
                        ...form_value_result,
                        serviceNameInstance: e.target.value.length>150
                    })
                }}
                onSelect={(e: any)=> set_service_select_input(e)}
                getPopupContainer={(node: any)=> getPopupNodeModal(node)}
            >
                <Select.Option key={'MongoDB'} value={'MongoDB'}>MongoDB</Select.Option>
                <Select.Option key={'PostgreSQL'} value={'PostgreSQL'}>PostgreSQL</Select.Option>
                <Select.Option key={'InfluxDB'} value={'InfluxDB'}>InfluxDB</Select.Option>
                <Select.Option key={'RabbitMQ'} value={'RabbitMQ'}>RabbitMQ</Select.Option>
            </Select>
        </Form.Item>
    </Col>);

    // todo modal service plan name element
    // eslint-disable-next-line
    const service_plan_name_ele = ()=>(<Col span={12} style={paddingLeft}>
        <Form.Item
            name={'servicePlanName'}
            label={'Service Plan Name'}
            labelCol={{span: 24}}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    max: 150,
                    message: intl.formatMessage({id: 'max_length'}, {length: 150})
                }
            ]}
            validateStatus={form_value_result.servicePlanName? 'error': undefined}
            help={form_value_result.servicePlanName?
                intl.formatMessage(
                    {id: 'max_length'},
                    {length: 150}
                ): null
            }
        >
            <Select
                showSearch
                notFoundContent={null}
                showArrow={false}
                onSearch={(e: string)=> {
                    form.setFieldsValue({servicePlanName: e || service_plan_select_input});
                    e&&set_service_plan_select_input(e)
                }}
                onKeyUp={(e: any)=>{
                    if(e.keyCode === 8){
                        form.setFieldsValue({servicePlanName: ''});
                        set_service_plan_select_input('')
                    }
                    set_form_value_result({
                        ...form_value_result,
                        servicePlanName: e.target.value.length>150
                    })
                }}
                onSelect={(e: any)=> set_service_plan_select_input(e)}
                getPopupContainer={(node: any)=> getPopupNodeModal(node)}
            >
                <Select.Option key={'Dedicated-Single-Small'} value={'Dedicated-Single-Small'}>Dedicated-Single-Small</Select.Option>
                <Select.Option key={'Dedicated-Single-Mini'} value={'Dedicated-Single-Mini'}>Dedicated-Single-Mini</Select.Option>
            </Select>
        </Form.Item>
    </Col>);

    // todo modal service category element
    // eslint-disable-next-line
    const service_category_ele = ()=>(<Col span={24} style={paddingRight}>
        <Form.Item
            name={'serviceCategory'}
            label={intl.formatMessage({id: 'service_category'})}
            labelCol={{span: 24}}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    max: 150,
                    message: intl.formatMessage({id: 'max_length'}, {length: 150})
                }
            ]}
            validateStatus={form_value_result.serviceCategory? 'error': undefined}
            help={form_value_result.serviceCategory?
                intl.formatMessage(
                    {id: 'max_length'},
                    {length: 150}
                ): null
            }
        >
            <Select
                showSearch
                notFoundContent={null}
                showArrow={false}
                onSearch={(e: string)=> {
                    form.setFieldsValue({serviceCategory: e || service_category_select_input});
                    e&&set_service_category_select_input(e)
                }}
                onKeyUp={(e: any)=>{
                    if(e.keyCode === 8){
                        form.setFieldsValue({serviceCategory: ''});
                        set_service_category_select_input('')
                    }
                    set_form_value_result({
                        ...form_value_result,
                        serviceCategory: e.target.value.length>150
                    })
                }}
                onSelect={(e: any)=> set_service_category_select_input(e)}
                getPopupContainer={(node: any)=> getPopupNodeModal(node)}
            >
                <Select.Option key={'EnSaaS'} value={'EnSaaS'}>EnSaaS</Select.Option>
            </Select>
        </Form.Item>
    </Col>);

    // todo modal pn info element
    // eslint-disable-next-line
    const pn_info_ele = ()=>(<Col span={24} className={'create-instance-parameters'}>
        <Row>
            <Col span={18} style={{marginBottom: '10px'}}>
                            <span className={'required-icon'}>
                                <FormattedMessage id={'dataService'}/>
                                &nbsp;&nbsp;
                                <Tooltip title={intl.formatMessage({id: 'enter_any_value'})}>
                                    <QuestionCircleOutlined className={'tooltip_question'} />
                                </Tooltip>
                            </span>
            </Col>
            <Col span={6} className={'align-right padding-right-10'}>
                <Button size={'small'} onClick={()=> addParameter('instance')}>
                    <PlusOutlined />
                </Button>
            </Col>
            {instance_keys.map((k: number) => (
                <Col key={k} span={24}>
                    <Row>
                        <Col span={11} className={'padding-right-10'}>
                            <Form.Item
                                name={`instanceValue${k}`}
                                rules ={[
                                    {
                                        pattern: /^[\S]+$/,
                                        message: intl.formatMessage({id: 'input_regexp_9'})
                                    },
                                    {
                                        required: true,
                                        message: intl.formatMessage({id: 'this_is_required'})
                                    }
                                ]}
                                validateStatus={check_data_service[k]? 'error': undefined}
                                help={check_data_service[k]?  intl.formatMessage({id: 'key_repeat'}, {keyEN: 'pn', keyZH: 'PN'}): null}
                            >
                                <Input placeholder={'980GEDPA000'} onChange={() =>check_parameter_key('instanceKey', instance_keys)}/>
                            </Form.Item>
                        </Col>
                        <Col span={11} className={'padding-right-10'}>
                            <Form.Item
                                name={`instanceKey${k}`}
                                rules ={[
                                    {
                                        required: true,
                                        message: intl.formatMessage({id: 'this_is_required'})
                                    },
                                    {
                                        pattern: /^[0-9]+$/,
                                        message: intl.formatMessage({id: 'input_regexp_3'})
                                    }
                                ]}
                            >
                                <Input placeholder={'1'}/>
                            </Form.Item>
                        </Col>
                        {instance_keys.length>1 && <Col span={2} className={'modal-icons modal-trash padding-right-10'}>
                            <DeleteOutlined onClick={() => removeParameter(k, 'instanceKey', instance_keys)}/>
                        </Col>}
                    </Row>
                </Col>
            ))}
        </Row>
    </Col>);

    const parameters_ele = (className: string) =>(<Col span={24} className={className}>
        <Row>
            <Col span={18} style={{marginBottom: '20px', paddingLeft: '11px'}}>
                <span><FormattedMessage id={'parameters'}/></span>
            </Col>
            <Col span={6} className={'align-right padding-right-10'}>
                <Button size={'small'} onClick={()=> addParameter('')}>
                    <PlusOutlined />
                </Button>
            </Col>
            {keys.map((k: number) => (
                <Col key={k} span={24}>
                    <Row>
                        <Col span={8} className={'padding-right-10'}>
                            <Form.Item
                                name={`key${k}`}
                                validateStatus={check_parameters[k]? 'error': undefined}
                                help={check_parameters[k]?  intl.formatMessage({id: 'key_repeat'}, {keyEN: intl.formatMessage({id: 'key'}).toLowerCase(), keyZH: intl.formatMessage({id: 'key'})}): null}
                                rules ={[
                                    {
                                        pattern: /^[\S]+$/,
                                        message: intl.formatMessage({id: 'input_regexp_9'})
                                    },
                                    {
                                        required: true,
                                        message: intl.formatMessage({id: 'this_is_required'})
                                    }
                                ]}
                            >
                                <Input placeholder={intl.formatMessage({id: 'key'})} onChange={() =>check_parameter_key('key', keys)}/>
                            </Form.Item>
                        </Col>
                        <Col span={6} className={'padding-right-10'}>
                            <Form.Item
                                name={`type${k}`}
                            >
                                <Select
                                    defaultValue={['string']}
                                    onChange={(e: any)=>{
                                        type_data[k]=e;
                                        set_type_data({...type_data});
                                        const form_value: any =form.getFieldsValue();
                                        form_value[`value${k}`] = e === 'boolean'? 'true': '';
                                        form.setFieldsValue(form_value);
                                    }}
                                >
                                    <Select.Option key={'string'} value={'string'}><FormattedMessage id={'string'}/></Select.Option>
                                    <Select.Option key={'integer'} value={'integer'}><FormattedMessage id={'integer'}/></Select.Option>
                                    <Select.Option key={'boolean'} value={'boolean'}><FormattedMessage id={'boolean'}/></Select.Option>
                                    <Select.Option key={'array'} value={'array'}><FormattedMessage id={'array'}/></Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8} className={'padding-right-10'}>
                            <Form.Item
                                name={`value${k}`}
                                rules ={[
                                    {
                                        pattern: type_data[k] === 'integer'?/^[0-9]+$/:/[\s\S]*/ ,
                                        message: intl.formatMessage({id: 'input_regexp_3'})
                                    }
                                ]}
                            >{type_data[k] === 'boolean'?
                                <Select defaultValue={['true']}>
                                    <Select.Option key={'true'} value={'true'}>true</Select.Option>
                                    <Select.Option key={'false'} value={'false'}>false</Select.Option>
                                </Select>:
                                <Input placeholder={intl.formatMessage({id: 'value'})}/>
                            }</Form.Item>
                        </Col>
                        <Col  span={2} className={'modal-icons modal-trash padding-right-10'}>
                            <DeleteOutlined onClick={() => removeParameter(k, 'key', keys)}/>
                        </Col>
                    </Row>
                </Col>
            ))}
        </Row>
    </Col>);

    const service_instance_name = (key: string) =>(<Col span={24}>
        <Form.Item
            name={'serviceInstanceName'}
            labelAlign={'left'}
            labelCol={{span: 24}}
            label={instance_name[modal_data.title as string || '']? intl.formatMessage({id: 'instance_name'}):'Service Instance Name'}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    pattern: /^[a-zA-Z0-9._-]+$/,
                    message: intl.formatMessage({id: 'input_regexp_8'})
                },
                {
                    max: 150,
                    message: intl.formatMessage({id: 'max_length'}, {length: 150})
                }
            ]}
            validateStatus={form_value_result.serviceInstanceName? 'error': undefined}
            help={form_value_result.serviceInstanceName?
                intl.formatMessage(
                    {id: 'name_repeat'},
                    {name: intl.formatMessage({id: 'service_instance'}).toLowerCase()}
                ): null
            }
        >
            <Input onChange={()=> check_service_instance_name(key)}/>
        </Form.Item>
    </Col>);

    const reactJson = (data: object|undefined) =>(<ReactJson
        src={data||{}}
        name={false}
        theme={'summerfruit:inverted'}
        style={{width: '100%', height: '300px', overflow: 'auto'}}
        indentWidth={2}
        iconStyle={'triangle'}
        displayDataTypes={false}
        displayObjectSize={false}
        enableClipboard={(e: any)=> {
            if(e.src !== "") {
                let copy_data: string = JSON.stringify(e.src);
                copy_data[0] === '"' && (copy_data = copy_data.slice(1));
                copy_data[copy_data.length - 1] === '"' && (copy_data = copy_data.slice(0, copy_data.length - 1));
                copy(copy_data);
            }else {
                copy(' ', {format: 'text/html'})
            }
        }}
    />);

    const internal_hosts_ele = (placeholder: string)=>(<Col span={24}>
        <Form.Item
            name={'internalHosts'}
            labelAlign={'left'}
            labelCol={{span: 24}}
            label={<span>
                <FormattedMessage id={'internal_hosts'}/>
                &nbsp;&nbsp;
                <Tooltip title={intl.formatMessage({id: 'host_role'}, {tag1: '<', tag2: '>'})}>
                    <QuestionCircleOutlined className={'tooltip_question'} />
                </Tooltip>
            </span>}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                // {
                //     pattern: /^[0-9.:,]+$/,
                //     message: intl.formatMessage({id: 'input_regexp_5'})
                // },
                {
                    max: 500,
                    message: intl.formatMessage({id: 'max_length'}, {length: 500})
                }
            ]}
        >
            <Input placeholder={placeholder}/>
        </Form.Item>
    </Col>);

    const external_hosts_ele = (placeholder: string)=>(<Col span={24}>
        <Form.Item
            name={'externalHosts'}
            labelAlign={'left'}
            labelCol={{span: 24}}
            label={intl.formatMessage({id: 'external_hosts'})}
            // label={<span>
            //     <FormattedMessage id={'external_hosts'}/>
            //     &nbsp;&nbsp;
            //     <Tooltip title={intl.formatMessage({id: 'host_role'}, {tag1: '<', tag2: '>'})}>
            //         <QuestionCircleOutlined className={'tooltip_question'} />
            //     </Tooltip>
            // </span>}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                // {
                //     pattern: /^[0-9.:,]+$/,
                //     message: intl.formatMessage({id: 'input_regexp_5'})
                // },
                {
                    max: 500,
                    message: intl.formatMessage({id: 'max_length'}, {length: 500})
                }
            ]}
        >
            <Input placeholder={placeholder}/>
        </Form.Item>
    </Col>);

    const username_ele = (span: number, style?: object, pattern?: boolean)=>(<Col span={span} style={style}>
        <Form.Item
            name={'username'}
            labelAlign={'left'}
            labelCol={{span: 24}}
            label={<FormattedMessage id="username" />}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    max: 50,
                    message: intl.formatMessage({id: 'max_length'}, {length: 50})
                },
                {
                    pattern: pattern?/^[a-zA-Z0-9._-]+$/: /[\s\S]*/,
                    message: intl.formatMessage({id: 'input_regexp_8'})
                }
            ]}
        >
            <Input />
        </Form.Item>
    </Col>);

    const password_ele = (span: number, style?: object, pattern?: boolean)=>(<Col span={span} style={style}>
        <Form.Item
            name={'password'}
            labelAlign={'left'}
            labelCol={{span: 24}}
            label={<FormattedMessage id="password" />}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    max: 50,
                    message: intl.formatMessage({id: 'max_length'}, {length: 50})
                },
                {
                    pattern: pattern?/^[a-zA-Z0-9._-]+$/: /[\s\S]*/,
                    message: intl.formatMessage({id: 'input_regexp_8'})
                }
            ]}
        >
            <Input />
        </Form.Item>
    </Col>);

    const ssl_ele = ()=>(<Col span={4} style={paddingLeft}>
        <Form.Item
            name={'ssl'}
            label={intl.formatMessage({id: 'ssl'})}
            labelCol={{span: 24}}
        >
            <Select getPopupContainer={(node: any)=> getPopupNodeModal(node)}>
                <Select.Option key={'true'} value={'true'}>true</Select.Option>
                <Select.Option key={'false'} value={'false'}>false</Select.Option>
            </Select>
        </Form.Item>
    </Col>);

    const dashboard_url_ele =(hidden: boolean, required: boolean)=>(<Col id={'dashboardUrl'} span={24} hidden={hidden}>
        <Form.Item
            name={'dashboardUrl'}
            labelAlign={'left'}
            labelCol={{span: 24}}
            label={intl.formatMessage({id:'dashboard_url'})}
            rules={[
                {
                    required: required,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    max: 1000,
                    message: intl.formatMessage({id: 'max_length'}, {length: 1000})
                }
            ]}
        >
            <Input placeholder={'http://<host>:<port>/#/login/<rabbitmq_username>/<rabbitmq_password>'}/>
        </Form.Item>
    </Col>);

    const authentication_database_ele = (hidden: boolean, required: boolean)=>(<Col id={'authenticationDatabase'} span={24} hidden={hidden}>
        <Form.Item
            name={'authenticationDatabase'}
            labelAlign={'left'}
            labelCol={{span: 24}}
            label={intl.formatMessage({id:'authentication_database'})}
            rules={[
                {
                    required: required,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    max: 100,
                    message: intl.formatMessage({id: 'max_length'}, {length: 100})
                }
            ]}
        >
            <Input />
        </Form.Item>
    </Col>);

    const deployment_properties_ele = ()=>(<Collapse.Panel
        key={'deploymentProperties'}
        header={intl.formatMessage({id: 'deployment_properties'})}
        className="modal-collapse-custom-panel"
    >
        <Row>
            <Col span={12} style={paddingRight}>
                <Form.Item
                    name={'location'}
                    label={intl.formatMessage({id: 'location'})}
                    labelCol={{span: 24}}
                    rules={[
                        {
                            max: 50,
                            message: intl.formatMessage({id: 'max_length'}, {length: 50})
                        }
                    ]}
                >
                    <Input placeholder={'sa / hz / je / arfa'}/>
                </Form.Item>
            </Col>
            <Col span={12} style={paddingLeft}>
                <Form.Item
                    name={'databaseVersion'}
                    label={intl.formatMessage({id: 'database_version'})}
                    labelCol={{span: 24}}
                    rules={[
                        {
                            max: 50,
                            message: intl.formatMessage({id: 'max_length'}, {length: 50})
                        }
                    ]}
                >
                    <Input placeholder={'3.6.6'}/>
                </Form.Item>
            </Col>
            <Col span={12} style={paddingRight}>
                <Form.Item
                    name={'vmType'}
                    label={intl.formatMessage({id: 'vmType'})}
                    labelCol={{span: 24}}
                    rules={[
                        {
                            max: 50,
                            message: intl.formatMessage({id: 'max_length'}, {length: 50})
                        }
                    ]}
                >
                    <Input placeholder={'Small / Medium / Large'}/>
                </Form.Item>
            </Col>
            <Col span={12} style={paddingLeft}>
                <Form.Item
                    name={'vmSize'}
                    label={intl.formatMessage({id: 'vmSize'})}
                    labelCol={{span: 24}}
                    rules={[
                        {
                            max: 50,
                            message: intl.formatMessage({id: 'max_length'}, {length: 50})
                        }
                    ]}
                >
                    <Input placeholder={'2c8g'}/>
                </Form.Item>
            </Col>
            <Col span={12} style={paddingRight}>
                <Form.Item
                    name={'persistentDiskSize'}
                    label={intl.formatMessage({id: 'persistent_disk_size'})}
                    labelCol={{span: 24}}
                    rules={[
                        {
                            pattern: /^[0-9]+$/,
                            message: intl.formatMessage({id: 'input_regexp_3'})
                        }
                    ]}
                >
                    <Input placeholder={'128000'}/>
                </Form.Item>
            </Col>
            <Col span={12} style={paddingLeft}>
                <Form.Item
                    name={'persistentDiskType'}
                    label={intl.formatMessage({id: 'persistent_disk_type'})}
                    labelCol={{span: 24}}
                    rules={[
                        {
                            max: 16,
                            message: intl.formatMessage({id: 'max_length'}, {length: 16})
                        }
                    ]}
                >
                    <Input placeholder={'128G'}/>
                </Form.Item>
            </Col>
        </Row>
    </Collapse.Panel>);

    const bindable_ele = (span: number, style?: object)=>(<Col span={span} style={style}>
        <Form.Item
            name={'bindable'}
            label={intl.formatMessage({id: 'bindable'})}
            labelCol={{span: 24}}
        >
            <Select getPopupContainer={(node: any)=> getPopupNodeModal(node)}>
                <Select.Option key={'true'} value={'true'}>true</Select.Option>
                <Select.Option key={'false'} value={'false'}>false</Select.Option>
            </Select>
        </Form.Item>
    </Col>);

    // todo modal other parameters element
    // eslint-disable-next-line
    const other_parameters_ele = ()=>(<Collapse.Panel
        key={'other-parameters'}
        header={intl.formatMessage({id: 'advanced_parameters'})}
        className="modal-collapse-custom-panel"
    >
        <Row>
            <Col span={12} style={paddingRight}>
                <Form.Item
                    name={'chargeType'}
                    label={intl.formatMessage({id: 'charge_type'})}
                    labelCol={{span: 24}}
                    rules={[
                        {
                            max: 50,
                            message: intl.formatMessage({id: 'max_length'}, {length: 50})
                        }
                    ]}
                    validateStatus={form_value_result.chargeType? 'error': undefined}
                    help={form_value_result.chargeType?
                        intl.formatMessage(
                            {id: 'max_length'},
                            {length: 50}
                        ): null
                    }
                >
                    <Select
                        showSearch
                        notFoundContent={null}
                        showArrow={false}
                        onSearch={(e: string)=> {
                            form.setFieldsValue({chargeType: e || charge_type_select_input});
                            e&&set_charge_type_select_input(e)
                        }}
                        onKeyUp={(e: any)=>{
                            if(e.keyCode === 8){
                                form.setFieldsValue({chargeType: ''});
                                set_charge_type_select_input('')
                            }
                            set_form_value_result({
                                ...form_value_result,
                                chargeType: e.target.value.length>50
                            })
                        }}
                        onSelect={(e: any)=> set_charge_type_select_input(e)}
                        getPopupContainer={(node: any)=> getPopupNodeModal(node)}
                    >
                        <Select.Option key={'Monthly'} value={'Monthly'}>Monthly</Select.Option>
                    </Select>
                </Form.Item>
            </Col>
            <Col span={12} style={paddingLeft}>
                <Form.Item
                    name={'serviceProperty'}
                    label={intl.formatMessage({id: 'service_property'})}
                    labelCol={{span: 24}}
                    rules={[
                        {
                            max: 50,
                            message: intl.formatMessage({id: 'max_length'}, {length: 50})
                        }
                    ]}
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col span={12} style={paddingRight}>
                <Form.Item
                    name={'userId'}
                    label={intl.formatMessage({id: 'userId'})}
                    labelCol={{span: 24}}
                    rules={[
                        {
                            max: 150,
                            message: intl.formatMessage({id: 'max_length'}, {length: 150})
                        }
                    ]}
                >
                    <Input />
                </Form.Item>
            </Col>
            {bindable_ele(12, paddingLeft)}
        </Row>
    </Collapse.Panel>);

    const dataCenter_code_ele = (span: number, style?: object)=>(<Col span={span} style={style}>
        <Form.Item
            name={'datacenterCode'}
            label={<FormattedMessage id="datacenter_code" />}
            labelCol={{span: 24}}
        >
            <Input disabled/>
        </Form.Item>
    </Col>);

    const broker_service_name_ele = (disabled: boolean)=>(<Col span={12} style={paddingRight}>
        <Form.Item
            name={'brokerServiceName'}
            label={<FormattedMessage id="service_name"/>}
            labelCol={{span: 24}}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    pattern: /^[a-zA-z0-9_\-.+]+$/,
                    message: intl.formatMessage({id: 'input_regexp_10'})
                }
            ]}
        >
            <Input placeholder={'RabbitMQ'} disabled={disabled}/>
        </Form.Item>
    </Col>);

    const broker_display_name_ele = (disable: boolean, span: number, style? : object)=>(<Col span={span} style={style}>
        <Form.Item
            name={'brokerDisplayName'}
            label={<span>
                <FormattedMessage id="service_name_in_secret" />
                &nbsp;&nbsp;
                <Tooltip title={intl.formatMessage({id: 'broker_display_name_tooltip'})}>
                    <QuestionCircleOutlined className={'tooltip_question'} />
                </Tooltip>
            </span>}
            labelCol={{span: 24}}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    pattern: /^[a-zA-z0-9_\-.+]+$/,
                    message: intl.formatMessage({id: 'input_regexp_10'})
                }
            ]}
        >
            <Input placeholder={'p-rabbitmq'} disabled={disable}/>
        </Form.Item>
    </Col>);

    const broker_service_id_ele = ()=>(<Col span={24}>
        <Form.Item
            name={'serviceId'}
            label={<FormattedMessage id="broker_service_id" />}
            labelCol={{span: 24}}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    pattern: /^[a-zA-z0-9_\-.+]+$/,
                    message: intl.formatMessage({id: 'input_regexp_10'})
                }
            ]}
        >
            <Input placeholder={'wise-paas-rabbitmq-service-broker'}/>
        </Form.Item>
    </Col>);

    const broker_plan_id_ele = ()=>(<Col span={24}>
        <Form.Item
            name={'planId'}
            label={<FormattedMessage id="broker_plan_id" />}
            labelCol={{span: 24}}
            rules={[
                {
                    required: true,
                    message: intl.formatMessage({id: 'this_is_required'})
                },
                {
                    pattern: /^[a-zA-z0-9_\-.+]+$/,
                    message: intl.formatMessage({id: 'input_regexp_10'})
                }
            ]}
        >
            <Input placeholder={'rabbitmq-wise-paas-dedicated'}/>
        </Form.Item>
    </Col>);

    return (
        <Modal
            title={intl.formatMessage({id:modal_data.title|| 'title'})}
            visible={modal_visible.toggle}
            width={modal_data.title === 'view' ? 800: 550}
            maskClosable={true}
            onCancel={cancel_handle}
            footer={<div>
                {(modal_data.title === 'view' || modal_data.title === 'support_title') ? '':
                    <Button onClick={cancel_handle}>
                        <FormattedMessage id={'cancel'}/>
                    </Button>
                }
                <Button type='primary' onClick={ok_handle} disabled={modal_loading}>
                    {modal_loading? <LoadingOutlined />: <FormattedMessage id={'ok'}/>}
                </Button>
            </div>}
        >
            {show_form[modal_data.type||'']&&<Form
                form={form}
                onFinish={on_finish}
            >
                {/*create secret||dccs*/}
                {show_secret[modal_data.title||'0'] &&modal_data.item && <Row>
                    {/*secret name*/}
                    {modal_data.item.name && <Col span={24} className={'padding-right-10'}>
                        <Form.Item
                            name={'name'}
                            labelAlign={'left'}
                            labelCol={{sm: 8, md: 4}}
                            wrapperCol={{sm: 16, md: 20}}
                            label={<span><FormattedMessage id={'name'}/><FormattedMessage id={':'}/></span>}
                            rules={[
                                {
                                    required: true,
                                    message: intl.formatMessage({id: 'this_is_required'})
                                },
                                {
                                    pattern: /^[a-z0-9.-]+$/,
                                    message: intl.formatMessage({id: 'input_regexp_6'})
                                },
                                {
                                    pattern: /^[^.-](.*[^.-])?$/,
                                    message: intl.formatMessage({id: 'input_regexp_2'})
                                },
                                {
                                    max: 150,
                                    message: intl.formatMessage({id: 'max_length'}, {length: 150})
                                }
                            ]}
                            validateStatus={form_value_result.name? 'error': undefined}
                            help={form_value_result.name?
                                intl.formatMessage(
                                    {id: 'name_repeat'},
                                    {name: intl.formatMessage({id: 'secret'}).toLowerCase()}
                                ): null
                            }
                        >
                            <Input
                                placeholder={intl.formatMessage(
                                {id: 'please_input'},
                                {type: intl.formatMessage({id: 'secret_name'}).toLowerCase()}
                                )}
                                onChange={check_name_value}
                            />
                        </Form.Item>
                    </Col>}
                    {/*dccs description*/}
                    {modal_data.item.description && <Col span={24} className={'padding-right-10'}>
                        <Form.Item
                            name={'description'}
                            labelAlign={'left'}
                            labelCol={{sm: 8, md: 5}}
                            wrapperCol={{sm: 16, md: 19}}
                            label={<span><FormattedMessage id={'description'}/><FormattedMessage id={':'}/></span>}
                            rules={[
                                {
                                    required: modal_data.type=== 'edit',
                                    message: intl.formatMessage({id: 'this_is_required'})
                                },
                                {
                                    pattern: /^[a-zA-Z0-9-._\s]+$/,
                                    message: intl.formatMessage({id: 'input_regexp_7'})
                                },
                                {
                                    max: 150,
                                    message: intl.formatMessage({id: 'max_length'}, {length: 150})
                                }
                            ]}
                        >
                            <Input placeholder={intl.formatMessage({id: 'please_input_description'})}/>
                        </Form.Item>
                    </Col>}
                    {/*cluster*/}
                    {modal_data.item.cluster && <Col span={8} className={'padding-right-10'}>
                        <Form.Item
                            name={'cluster'}
                            label={intl.formatMessage({id: 'cluster'})}
                            labelCol={{span: 24}}
                            rules={[
                                {
                                    required: true,
                                    message: intl.formatMessage({id: 'this_is_required'})
                                }
                            ]}
                            validateStatus={form_value_result.cluster? 'error': undefined}
                            help={form_value_result.cluster? intl.formatMessage({id: 'no_cluster_found'}): null}
                        >
                            <Select
                                disabled={cluster_name.length<=0}
                                onChange={(e: any) => {set_cluster_selected(e); check_name_value()}}
                                showSearch
                                filterOption={(input: any, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                getPopupContainer={(node: any)=> getPopupNodeModal(node)}
                            >
                                {cluster_name.map((item: any) => (
                                    item.name && <Select.Option key={item.key} value={item.key}>{item.name}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>}
                    {/*workspace*/}
                    {modal_data.item.workspace && <Col span={8} className={'padding-right-10'}>
                        <Form.Item
                            name={'workspace'}
                            label={intl.formatMessage({id: 'workspace'})}
                            labelCol={{span: 24}}
                            rules={[
                                {
                                    required: true,
                                    message: intl.formatMessage({id: 'this_is_required'})
                                }
                            ]}
                            validateStatus={form_value_result.workspace? 'error': undefined}
                            help={form_value_result.workspace?  intl.formatMessage({id: 'no_workspace_found'}): null}
                        >
                            <Select
                                disabled={workspace_name.length<=0}
                                onChange={(e: any) =>{set_workspace_selected(e); check_name_value()}}
                                showSearch
                                filterOption={(input: any, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                getPopupContainer={(node: any)=> getPopupNodeModal(node)}
                            >
                                {workspace_name.map((item: any) => (
                                    item.name && <Select.Option key={JSON.stringify({id:item.id, name:item.name})} value={JSON.stringify({id:item.id, name:item.name})}>{item.name}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>}
                    {/*namespace*/}
                    {modal_data.item.namespace && <Col span={8} className={'padding-right-10'}>
                        <Form.Item
                            name={'namespace'}
                            label={intl.formatMessage({id: 'namespace'})}
                            labelCol={{span: 24}}
                            rules={[
                                {
                                    required: true,
                                    message: intl.formatMessage({id: 'this_is_required'})
                                }
                            ]}
                            validateStatus={form_value_result.namespace? 'error': undefined}
                            help={form_value_result.namespace?  intl.formatMessage({id: 'no_namespace_found'}): null}
                        >
                            <Select
                                disabled={namespace_name.length<=0}
                                showSearch
                                filterOption={(input: any, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={check_name_value}
                                getPopupContainer={(node: any)=> getPopupNodeModal(node)}
                            >
                                {namespace_name.map((item: any) => (
                                    item.name && <Select.Option key={item.key} value={item.key}>{item.name}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>}
                    {/*database*/}
                    {(modal_data.item.db || modal_data.item.IoTHub) && <Col span={24} className={'padding-right-10'}>
                        <Form.Item
                            name={modal_data.item.db?'db': 'IoTHub'}
                            label={<span>
                                {intl.formatMessage({id: modal_data.item.db? 'db_name': 'vhost_name'})}
                                &nbsp;&nbsp;
                                <Tooltip title={(
                                    <FormattedMessage
                                        id={'db_help_tooltip'}
                                        values={{name: intl.formatMessage({id: modal_data.item.db? 'db_name': 'vhost_name'})}}
                                    />
                                )}>
                                    <QuestionCircleOutlined className={'tooltip_question'} />
                                </Tooltip>
                            </span>}
                            labelCol={{span: 24}}
                            validateStatus={db_select_input ? testSelectDB(db_select_input) ? 'success' :'error': 'success'}
                            help={
                                db_select_input ? testSelectDB(db_select_input)? '': (
                                    <FormattedMessage
                                        id={'db_help_message'}
                                        values={{name: intl.formatMessage({id: modal_data.item.db? 'db_name': 'vhost_name'})}}
                                    />
                                ): null
                            }
                            validateTrigger={'onChange'}
                        >
                            <Select
                                showSearch
                                notFoundContent={null}
                                showArrow={false}
                                onSearch={(e: string)=> {
                                    modal_data.item && (
                                        modal_data.item.db ?
                                        form.setFieldsValue({db: e || db_select_input}):
                                        form.setFieldsValue({IoTHub: e || db_select_input})
                                    );
                                    e&&set_db_select_input(e)
                                }}
                                onKeyUp={(e: any)=>{if(e.keyCode === 8){
                                    modal_data.item && (
                                        modal_data.item.db ?
                                            form.setFieldsValue({db: ''}):
                                            form.setFieldsValue({IoTHub: ''})
                                    );
                                    set_db_select_input('')
                                }}}
                                onSelect={(e: any)=> set_db_select_input(e)}
                                getPopupContainer={(node: any)=> getPopupNodeModal(node)}
                            >
                                {db_list&&db_list.map((item: string, key: number)=>(
                                    <Select.Option key={key} value={item} disabled={!testSelectDB(item)}>{item}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>}
                    {/*parameters*/}
                    {modal_data.item.parameters&& parameters_ele('')}
                    {/*额外参数*/}
                    {modal_data.item.rmq&&<Col span={24}>
                        <Collapse
                            bordered={false}
                            className={'modal-collapse'}
                        >
                            <Collapse.Panel
                                key={'rmq-parameters'}
                                header={intl.formatMessage({id: 'advanced_parameters'})}
                                className="modal-collapse-custom-panel"
                            >
                                <Row>
                                    <Col span={24}>
                                        <Form.Item
                                            name={'rmqRole'}
                                            label={intl.formatMessage({id: 'role'})}
                                            labelCol={{span: 24}}
                                        >{modal_data.item.rmqRole ?
                                            <Select
                                                getPopupContainer={(node: any) => node.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode}>
                                                <Select.Option key={''} value={''}>{''}</Select.Option>
                                                <Select.Option key={'management'} value={'management'}>Management</Select.Option>
                                                <Select.Option key={'policymaker'} value={'policymaker'}>Policymaker</Select.Option>
                                                <Select.Option key={'monitoring'} value={'monitoring'}>Monitoring</Select.Option>
                                                <Select.Option key={'administrator'} value={'administrator'}>Administrator</Select.Option>
                                                <Select.Option key={'impersonator'} value={'impersonator'}>Impersonator</Select.Option>
                                            </Select>:
                                            <Select
                                                getPopupContainer={(node: any) => node.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode}>
                                                <Select.Option key={''} value={''}>{''}</Select.Option>
                                                <Select.Option key={'management'} value={'management'}>Management</Select.Option>
                                            </Select>
                                        }</Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            name={'rmqTopicRead'}
                                            label={'Topic Read Path'}
                                            labelCol={{span: 24}}
                                        >
                                            <Input placeholder={intl.formatMessage({id: 'please_input'}, {type: 'topic read path'})}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            name={'rmqTopicWrite'}
                                            label={'Topic Write Path'}
                                            labelCol={{span: 24}}
                                        >
                                            <Input placeholder={intl.formatMessage({id: 'please_input'}, {type: 'topic write path'})}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Collapse.Panel>
                        </Collapse>
                    </Col>}
                </Row>}

                {/*create instance*/}
                {modal_data.title === 'subscription_title' && <Row className={'subscription_content'}>
                    {/*subscription*/}
                    {/*{modal_data?.item?.subscription_all && subscription_ele()}*/}
                    {/*serviceInstanceId*/}
                    {service_instance_id_ele(false)}
                    {/*transactionId*/}
                    {/*{transaction_id_ele()}*/}
                    {/*serviceName*/}
                    {/*{service_name_ele()}*/}
                    {/*servicePlanName*/}
                    {/*{service_plan_name_ele()}*/}
                    {/*serviceCategory*/}
                    {/*{service_category_ele()}*/}
                    {/*PN Info*/}
                    {/*{pn_info_ele()}*/}
                    {/*internalHosts*/}
                    {internal_hosts_ele('<host1>:<port1>,<host2>:<port2>,<host3>:<port3>')}
                    {/*externalHosts*/}
                    {external_hosts_ele('dds-xxx.mongodb.rds.aliyuncs.com:3717')}
                    {/*username*/}
                    {username_ele(10, paddingRight, false)}
                    {/*password*/}
                    {password_ele(10, paddingLR, false)}
                    {/*ssl*/}
                    {ssl_ele()}
                    {/*dashboardUrl*/}
                    {dashboard_url_ele(false,false)}
                    {/*authenticationDatabase*/}
                    {authentication_database_ele(false,false)}
                    {/*bindable*/}
                    {bindable_ele(24)}
                    {/*非必填参数*/}
                    <Col span={24} style={{marginTop: '15px'}}>
                        <Collapse
                            bordered={false}
                            className={'modal-collapse'}
                            accordion={true}
                        >
                            {deployment_properties_ele()}
                            {/*{other_parameters_ele()}*/}
                        </Collapse>
                    </Col>
                    {/*parameters*/}
                    {parameters_ele('parameters-item')}
                </Row>}

                {/*edit instance*/}
                {modal_data.title === 'edit_instance' && <Row className={'subscription_content'}>
                    {internal_hosts_ele('<host1>:<port1>,<host2>:<port2>,<host3>:<port3>')}
                    {external_hosts_ele('dds-xxx.mongodb.rds.aliyuncs.com:3717')}
                    {username_ele(create_instance_info[1]? 10: 12, paddingRight, false)}
                    {password_ele(create_instance_info[1]? 10: 12, paddingLR, false)}
                    {create_instance_info[1] && ssl_ele()}
                    {create_instance_info[2] && authentication_database_ele(false,true)}
                    <Col span={24}>
                        <Form.Item name='updateSecret' valuePropName="checked" style={{marginTop: "15px"}}>
                            <Checkbox><FormattedMessage id='update_secret'/></Checkbox>
                        </Form.Item>
                    </Col>
                    {form.getFieldValue("updateSecret") &&
                    <Form.Item name='editInstanceCheckbox' valuePropName="checked">
                        <Checkbox><FormattedMessage id='edit_instance_checkout_msg'/></Checkbox>
                    </Form.Item>}
                </Row>}

                {/*overview create dedicated*/}
                {modal_data.title === 'overview_create_dedicated' && <Row className={'subscription_content'}>
                    {/*subscription*/}
                    {/*{subscription_ele()}*/}
                    {/*serviceInstanceId*/}
                    {service_instance_id_ele(false)}
                    {/*serviceInstanceName*/}
                    {/*{service_instance_name()}*/}
                    {/*transactionId*/}
                    {/*{transaction_id_ele()}*/}
                    {/*serviceName*/}
                    {/*{service_name_ele()}*/}
                    {/*servicePlanName*/}
                    {/*{service_plan_name_ele()}*/}
                    {/*serviceCategory*/}
                    {/*{service_category_ele()}*/}
                    {/*PN Info*/}
                    {/*{pn_info_ele()}*/}
                    {/*internalHosts*/}
                    {internal_hosts_ele('<host1>:<port1>,<host2>:<port2>,<host3>:<port3>')}
                    {/*externalHosts*/}
                    {external_hosts_ele('dds-xxx.mongodb.rds.aliyuncs.com:3717')}
                    {/*username*/}
                    {username_ele(10, paddingRight, true)}
                    {/*password*/}
                    {password_ele(10, paddingLR, true)}
                    {/*ssl*/}
                    {ssl_ele()}
                    {/*dashboardUrl*/}
                    {dashboard_url_ele(hide_dashboard[service_name],!hide_dashboard[service_name])}
                    {/*authenticationDatabase*/}
                    {authentication_database_ele(hide_authentication_database[service_name],!hide_authentication_database[service_name])}
                    {/*bindable*/}
                    {bindable_ele(24)}
                    {/*非必填参数*/}
                    <Col span={24} style={{marginTop: '15px'}}>
                        <Collapse
                            bordered={false}
                            className={'modal-collapse'}
                            accordion={true}
                        >
                            {deployment_properties_ele()}
                            {/*{other_parameters_ele()}*/}
                        </Collapse>
                    </Col>
                    {/*parameters*/}
                    {parameters_ele('parameters-item')}
                </Row>}

                {/*overview create shared*/}
                {modal_data.title === 'overview_create_shared' && <Row className={'overview-create'}>
                    {/*service name*/}
                    <Col span={24}>
                        <Form.Item
                            name={'overviewServiceName'}
                            label={<FormattedMessage id="service_name"/>}
                            labelCol={{span: 24}}
                        >
                            <Input disabled/>
                        </Form.Item>
                    </Col>
                    {/*plan*/}
                    <Col span={12} style={paddingRight}>
                        <Form.Item
                            name={'overviewPlan'}
                            label={<FormattedMessage id="plan_name"/>}
                            labelCol={{span: 24}}
                        >
                            <Input disabled/>
                        </Form.Item>
                    </Col>
                    {/*dataCenter code*/}
                    {dataCenter_code_ele(12, paddingRight)}
                    {/*pseudo ID*/}
                    <Col span={24}>
                        <Form.Item
                            name={'pseudoID'}
                            label={<FormattedMessage id="pseudo_id"/>}
                            labelCol={{span: 24}}
                            rules={[
                                {
                                    required: true,
                                    message: intl.formatMessage({id: 'this_is_required'})
                                },
                                {
                                    max: 100,
                                    message: intl.formatMessage({id: 'max_length'}, {length: 100})
                                }
                            ]}
                        >
                            <Input placeholder={'apps-<service_name>-production-001'}/>
                        </Form.Item>
                    </Col>
                    {/*internal hosts*/}
                    {internal_hosts_ele('127.0.0.1:27017,127.0.0.2:27017,127.0.0.3:27017')}
                    {/*external hosts*/}
                    {external_hosts_ele('127.0.0.1:27017,127.0.0.2:27017,127.0.0.3:27017')}
                    {/*username*/}
                    {username_ele(10, paddingRight, true)}
                    {/*password*/}
                    {password_ele(10, paddingLR, true)}
                    {/*ssl*/}
                    {ssl_ele()}
                    {/*authenticationDatabase*/}
                    {authentication_database_ele(!overviewATDB[modal_data?.itemValue?.overview_service_name || ''], overviewATDB[modal_data?.itemValue?.overview_service_name || ''])}
                    {/*deployment properties*/}
                    <Col span={24} style={{marginTop: '15px'}}>
                        <Collapse
                            bordered={false}
                            className={'modal-collapse'}
                            accordion={true}
                        >{deployment_properties_ele()}</Collapse>
                    </Col>
                    {/*parameters*/}
                    {parameters_ele('parameters-item')}
                </Row>}

                {/*rename instance*/}
                {modal_data.title === 'rename_instance' && <Row>{service_instance_name('instance_list_item_selected')}</Row>}
                {modal_data.title === 'rename_instance_overview' && <Row>{service_instance_name('overview_list_item_selected')}</Row>}

                {/*create broker*/}
                {modal_data.title === 'create_broker_title' && <Row className={'broker-create'}>
                    {/*service name*/}
                    {broker_service_name_ele(false)}
                    {/*service name in secret*/}
                    {broker_display_name_ele(false, 12, paddingLeft)}
                    {/*protocol*/}
                    <Col span={4} style={paddingRight}>
                        <Form.Item
                            name={'protocol'}
                            label={<FormattedMessage id="protocol" />}
                            labelCol={{span: 24}}
                            rules={[
                                {
                                    required: true,
                                    message: intl.formatMessage({id: 'this_is_required'})
                                }
                            ]}
                        >
                            <Select getPopupContainer={(node: any)=> getPopupNodeModal(node)}>
                                <Select.Option key={'http'} value={'http'}>http</Select.Option>
                                <Select.Option key={'https'} value={'https'}>https</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    {/*broker host*/}
                    <Col span={16} style={paddingLR}>
                        <Form.Item
                            name={'brokerHost'}
                            label={<FormattedMessage id="broker_host" />}
                            labelCol={{span: 24}}
                            rules={[
                                {
                                    required: true,
                                    message: intl.formatMessage({id: 'this_is_required'})
                                },
                                {
                                    pattern: /^[a-zA-Z0-9._-]+$/,
                                    message: intl.formatMessage({id: 'input_regexp_8'})
                                }
                            ]}
                        >
                            <Input placeholder={'rabbitmq.sm.ensaas.en.internal'}/>
                        </Form.Item>
                    </Col>
                    {bindable_ele(4, paddingLeft)}
                    {/*username*/}
                    {username_ele(12, paddingRight, true)}
                    {/*password*/}
                    {password_ele(12, paddingLeft, true)}
                    {/*service ID*/}
                    {broker_service_id_ele()}
                    {/*plan ID*/}
                    {broker_plan_id_ele()}
                    {/*plan*/}
                    <Col span={24} className={'parameters-item'} style={{marginTop: '10px'}}>
                        <Row>
                            <Col span={18} style={{marginBottom: '20px'}} className={'required-icon'}>
                                <span><FormattedMessage id="plan_sp" /></span>
                            </Col>
                            <Col span={6} className={'align-right padding-right-10'}>
                                <Button size={'small'} onClick={()=> addParameter('broker')}>
                                    <PlusOutlined />
                                </Button>
                            </Col>
                            {broker_plan_keys.map((k: number) => (
                                <Col key={k} span={24}>
                                    <Row>
                                        <Col span={22} className={'padding-right-10'}>
                                            <Form.Item
                                                name={`brokerPlan${k}`}
                                                validateStatus={check_broker_plan[k]? 'error': undefined}
                                                help={check_broker_plan[k]?  intl.formatMessage({id: 'key_repeat'}, {keyEN: 'plan_sp', keyZH: 'Plan'}): null}
                                                rules ={[
                                                    {
                                                        required: true,
                                                        message: intl.formatMessage({id: 'this_is_required'})
                                                    },
                                                    {
                                                        pattern: /^[a-zA-z0-9_\-.+]+$/,
                                                        message: intl.formatMessage({id: 'input_regexp_10'})
                                                    }
                                                ]}
                                            >
                                                <Input onChange={() =>check_parameter_key('brokerPlan', broker_plan_keys)}/>
                                            </Form.Item>
                                        </Col>
                                        <Col  span={2} className={'modal-icons modal-trash padding-right-10'} hidden={broker_plan_result[k] === 1 || broker_plan_result[k] === 2 || broker_plan_keys.length <= 1}>
                                            <DeleteOutlined onClick={() => removeParameter(k, 'brokerPlan', broker_plan_keys)}/>
                                        </Col>
                                        <Col  span={2} className={'modal-icons modal-check padding-right-10'} hidden={!(broker_plan_result[k] === 1)}>
                                            <CheckOutlined/>
                                        </Col>
                                        <Col  span={2} className={'modal-icons modal-close padding-right-10'} hidden={!(broker_plan_result[k] === 2)}>
                                            <CloseOutlined/>
                                        </Col>
                                    </Row>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>}

                {/*update broker*/}
                {modal_data.title === 'update_broker_title' && <Row className={'broker-update'}>
                    {/*service name*/}
                    {broker_service_name_ele(true)}
                    {/*plan*/}
                    <Col span={12} style={paddingLeft}>
                        <Form.Item
                            name={'brokerPlan'}
                            label={<FormattedMessage id="plan_sp" />}
                            labelCol={{span: 24}}
                            rules ={[
                                {
                                    required: true,
                                    message: intl.formatMessage({id: 'this_is_required'})
                                },
                                {
                                    pattern: /^[a-zA-z0-9_\-.+]+$/,
                                    message: intl.formatMessage({id: 'input_regexp_10'})
                                }
                            ]}
                        >
                            <Input disabled/>
                        </Form.Item>
                    </Col>
                    {/*display name*/}
                    {broker_display_name_ele(false, 20, paddingRight)}
                    {/*bindable*/}
                    {bindable_ele(4, paddingLeft)}
                    {/*broker url*/}
                    <Col span={24}>
                        <Form.Item
                            name={'brokerUrl'}
                            label={<FormattedMessage id="broker_url" />}
                            labelCol={{span: 24}}
                            rules ={[
                                {
                                    required: true,
                                    message: intl.formatMessage({id: 'this_is_required'})
                                },
                                {
                                    pattern: /^[a-zA-Z0-9_\-./@:]+$/,
                                    message: intl.formatMessage({id: 'input_regexp_11'})
                                }
                            ]}
                        >
                            <Input/>
                        </Form.Item>
                    </Col>
                    {/*username*/}
                    {username_ele(12, paddingRight, true)}
                    {/*password*/}
                    {password_ele(12, paddingLeft, true)}
                    {/*service id*/}
                    {broker_service_id_ele()}
                    {/*plan id*/}
                    {broker_plan_id_ele()}
                </Row>}
            </Form>}


            {/*confirm*/}
            {(modal_data.title === 'confirm' || modal_data.title === 'support_title')&&<Row>
                <Col span={24}>
                    {modal_data.confirmContent}
                </Col>
            </Row>}

            {/*view*/}
            {modal_data.title === 'view'&&<Row>
                <Col span={24} className="px-20">{modal_data.jsonView.length>0&&
                    <Tabs defaultActiveKey={modal_data.jsonView[0].title} size={'small'}>{
                        modal_data.jsonView.map((item: jsonViewType)=>(
                            <Tabs.TabPane key={item.title} tab={intl.formatMessage({id: item.title})}>{reactJson(item.data)}</Tabs.TabPane>
                        ))
                    }</Tabs>
                }
                </Col>
            </Row>}

        </Modal>
    );
};

export default injectIntl(Modals);
